import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import Swal from 'sweetalert2';
import { API_BULK_STATUS, capitalize } from '../../utils';
import ButtonLoad from '../ButtonLoad';
import Select from 'react-select';
import DoughnutChart from '../DoughnutChart/DoughnutChart';
import ProgressBar from '../ProgressBar';
import readXlsxFile from 'read-excel-file';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment-timezone';
import './BulkModal.scss';
import AWS_Lambda from '../../aws/aws';
import axios from 'axios';

// submitFormGroups Form group
const BulkModal = ({
  title,
  currentClientId,
  currentClientSocialNetworks,
  currentClientTimeZone,
  currentCustomerName,
  currentGroupId,
  currentClients
}) => {
  const [isBulking, setBulking] = useState(false);
  const [selectedClients, setSelectedClients] = useState([]);
  const [dropdownClients, setDropdownClients] = useState([]);
  const [progress, setProgress] = useState(0);
  const [loaded, setLoaded] = useState(0);

  const modalDismiss = useRef(null);
  const formBulk = useRef(null);
  const resetForm = useRef(null);
  const fileBulk = useRef(null);
  const clientsSelected = useRef(null);
  const checkFb = useRef(null);
  const checkGmb = useRef(null);
  const checkTw = useRef(null);
  const checkIg = useRef(null);

  useEffect(() => {
    if (currentClients) {
      let arr = currentClients.map((client, index) => {
        return {
          value: client,
          label: client
        };
      });

      setSelectedClients(arr);
      setDropdownClients([]);
    }
  }, [currentClients]);

  const fileToBase64 = (file, callBack) => {
    file = file.files[0];
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      callBack(reader.result);
    };
    reader.onerror = function (error) {
      console.warn('Error: ', error);
    };
  };

  const checkFormatBulk = async (file) => {
    let res = await readXlsxFile(file).then(async (rows) => {
      if (
        rows[0][0] !== 'Year' ||
        rows[0][1] !== 'Month' ||
        rows[0][2] !== 'Day' ||
        rows[0][3] !== 'Hour' ||
        rows[0][4] !== 'Minute' ||
        rows[0][5] !== 'AmPm' ||
        rows[0][6] !== 'All networks message' ||
        rows[0][7] !== 'Attached image' ||
        rows[0][8] !== 'Is Draft?'
      ) {
        let msg = `The file has the wrong column headers.<br/><br/>Remember:<br/><small>Year, Month, Day, Hour, Minute, AmPm,<br/> All networks message, Attached image, Is Draft?.</small>`;
        return { valid: false, msg };
      }
      for (let index = 1; index < rows.length; index++) {
        rows[index][1] = parseInt(rows[index][1]);
        rows[index][2] = parseInt(rows[index][2]);
        rows[index][3] = parseInt(rows[index][3]);
        rows[index][4] = parseInt(rows[index][4]);
        rows[index][5] = rows[index][5].toLowerCase();
        const row = rows[index];
        let year = row[0];
        let month = row[1];
        let day = row[2];
        let hour = row[3];
        let min = row[4];
        let ampm = row[5];
        let message = row[6];
        let url = row[7];
        let isDraft = row[8];

        if (
          typeof year !== 'number' ||
          parseInt(year) > 2025 ||
          parseInt(year) < 2021
        ) {
          let msg = `Wrong year "<strong>${year}</strong>" in row ${
            index + 1
          } .`;
          return { valid: false, msg };
        }
        if (
          typeof month !== 'number' ||
          parseInt(month) > 12 ||
          parseInt(month) < 1
        ) {
          let msg = `Wrong month "<strong>${month}</strong>" in row ${
            index + 1
          }.`;
          return { valid: false, msg };
        }
        if (
          typeof day !== 'number' ||
          parseInt(day) > 31 ||
          parseInt(day) < 1
        ) {
          let msg = `Wrong day "<strong>${day}</strong>" in row ${index + 1}.`;
          return { valid: false, msg };
        }
        if (
          typeof hour !== 'number' ||
          parseInt(hour) > 12 ||
          parseInt(hour) < 1
        ) {
          let msg = `Wrong hour "<strong>${hour}</strong>" in row ${
            index + 1
          }.`;
          return { valid: false, msg };
        }
        if (
          typeof min !== 'number' ||
          parseInt(min) > 60 ||
          parseInt(min) < 0
        ) {
          let msg = `Wrong minute "<strong>${min}</strong>" in row ${
            index + 1
          }.`;
          return { valid: false, msg };
        }
        if (ampm !== 'am' && ampm !== 'pm') {
          let msg = `Wrong AmPm "<strong>${ampm}</strong>" in row ${
            index + 1
          }.`;
          return { valid: false, msg };
        }
        if (typeof message !== 'string' || message.length > 500) {
          let msg = `Wrong message in row ${index + 1}.`;
          return { valid: false, msg };
        }

        if (url !== null) {
          let res = await imageExists(url);
          if (res < 200 || res > 300) {
            let msg = `Bad url in row ${index + 1}.`;
            return { valid: false, msg };
          }
        } else {
          if (isDraft !== null) {
            if (String(isDraft).toLowerCase().trim() !== 'true') {
              let msg = `Bad isDraft attribute in row ${index + 1}.`;
              return { valid: false, msg };
            }
          } else {
            let msg = `Bad url or select isDraft attribute in row ${
              index + 1
            }.`;
            return { valid: false, msg };
          }
        }
      }
      return { valid: true };
    });
    return res;
  };

  const checkColumnsBulk = async (file) => {
    let res = await readXlsxFile(file).then(async (data) => {
      return data.length;
    });
    console.log(res);
    return res;
  };

  const imageExists = (image_url) => {
    const proxyurl = 'https://adlersocial-cors-anywhere.herokuapp.com/';
    let res = fetch(proxyurl + image_url)
      .then((response) => {
        console.log(response.status);
        return response.status;
      })
      .catch((err) => {
        return 200;
      });
    return res;
  };

  const submitForm = async (e) => {
    e.preventDefault();
    setBulking(true);

    let setClients = clientsSelected.current
      ? clientsSelected.current.props.value
      : undefined;

    if (currentClientId !== undefined || setClients.length > 0) {
      if (fileBulk.current.files[0] === undefined) {
        Swal.fire({
          title: 'Error!',
          text: 'Please add the file.'
        }).then(() => {
          setBulking(false);
          setProgress(0);
          setLoaded(0);
        });
        return;
      }

      let fileOk = await checkFormatBulk(fileBulk.current.files[0]);
      if (!fileOk.valid) {
        Swal.fire({
          title: 'Error!',
          html: '<p>' + fileOk.msg + '</p>'
        }).then(() => {
          setBulking(false);
          setProgress(0);
          setLoaded(0);
        });
        fileBulk.current.innerHTML = '';
        return;
      }
      let fileColumns = await checkColumnsBulk(fileBulk.current.files[0]);
      var setData = {};
      var facebook = checkFb?.current ? checkFb.current.checked : false;
      var twitter = checkTw?.current ? checkTw?.current.checked : false;
      var gmb = checkGmb?.current ? checkGmb.current.checked : false;
      var ig = checkIg?.current ? checkIg.current.checked : false;
      fileToBase64(fileBulk.current, (res) => {
        let base64File = res.split(';base64,')[1];
        setData['file'] = base64File;
        setData['facebook'] = facebook;
        setData['twitter'] = twitter;
        setData['googleMyBusiness'] = gmb;
        setData['instagram'] = ig;
        setData['clientId'] = currentClientId || false;
        if (setClients) {
          setData['clients'] = setClients;
        }
        setData['dateNavigator'] = new Date();
        setData['currentClientTimeZone'] = currentClientTimeZone;
        const bulkId = uuidv4();
        setData['bulkId'] = bulkId;
        setData['bulkColumns'] = fileColumns - 1;
        setData['createdAt'] = moment.utc().unix();
        setData['createdBy'] = currentCustomerName;

        if (!(gmb || twitter || facebook || ig)) {
          Swal.fire({
            title: 'Error!',
            text: 'Please select a social network.'
          });
          setBulking(false);
          return;
        }

        let interval;

        let params = {
          FunctionName: process.env.REACT_APP_BULK_LAMBDA, // the lambda function we are going to invoke
          Payload: JSON.stringify({ body: JSON.stringify(setData) })
        };

        {
          const { loaded, total } = 0;
          setLoaded(Math.round((loaded * 100) / total));

          interval = setInterval(() => {
            axios
              .post(API_BULK_STATUS, { bulkId: bulkId })
              .then((response) => {
                console.log('interval');
                if (response.data > progress && isBulking) {
                  setProgress(response.data);
                }
              })
              .catch((error) => {
                console.warn('Error: ', error);
              });
          }, 300);
        }

        AWS_Lambda.invoke(params)
          .promise()
          .then((res) => {
            let response = JSON.parse(res.Payload);
            let response_body = JSON.parse(response.body);
            console.log(response_body);
            if (response.statusCode === 200) {
              clearInterval(interval);
              setBulking(false);
              setProgress(0);
              setLoaded(0);
              let wrapper = document.createElement('div');
              ReactDOM.render(<DoughnutChart data={response_body} />, wrapper);
              let chart = wrapper.firstChild;
              Swal.fire({
                title: 'Success, Bulk finished!.',
                type: 'success',
                html: chart,
                confirmButtonText: 'Great!',
                customClass: { confirmButton: 'adler-outline-btn pd-x-30' }
              });
            } else {
              clearInterval(interval);
              setBulking(false);
              setProgress(0);
              setLoaded(0);
              Swal.fire({
                title: 'Error!',
                type: 'error',
                text: response_body.message
              });
            }

            if (resetForm?.current !== null) {
              resetForm.current.click();
            }

            setBulking(false);
            setProgress(0);
            setLoaded(0);
            if (modalDismiss?.current !== undefined) {
              modalDismiss.current.click();
            }
          })
          .catch((error) => {
            let message;

            if (error.response && error.response.data) {
              message = error.response.data.message;
            } else {
              message = 'Bulk Error';
            }

            if (error)
              Swal.fire({
                title: 'Error!',
                type: 'error',
                text: message
              });
            clearInterval(interval);
            setBulking(false);
            setProgress(0);
            setLoaded(0);
            console.warn('Error: ', error);
          });
      });
    } else {
      Swal.fire({
        title: 'Error!',
        icon: 'error',
        text: `Have problems with ${setClients ? 'Group' : 'Client'}.`
      });
      setBulking(false);
      setProgress(0);
      setLoaded(0);
    }
  };

  // Here we update the state depending on adding or removing elements
  const handleChange = (value, { action, removedValue }) => {
    switch (action) {
      // Remove selected option
      case 'remove-value':
        setSelectedClients(
          selectedClients.filter((val) => val !== removedValue)
        );
        setDropdownClients([...dropdownClients, removedValue]);
        break;
      // Add a selected option
      case 'select-option':
        setSelectedClients([...selectedClients, value[value.length - 1]]);
        setDropdownClients(
          dropdownClients.filter((val) => val !== value[value.length - 1])
        );
        break;
      // Clear selected options
      case 'clear':
        setSelectedClients([]);
        selectedClients.forEach((client) => {
          setDropdownClients([...dropdownClients, client]);
        });
        break;
      default:
        return;
    }
  };

  let viewPage = title === 'posts' ? 1 : 0;
  let clientSocialNetworks = !viewPage
    ? { facebook: true, twitter: true, googleMyBusiness: true, instagram: true }
    : currentClientSocialNetworks;

  return (
    <div>
      <div
        className="modal fade"
        id="BulkModal"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="BulkModal"
        aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className={`modal-content tx-14 ${isBulking ? 'disable' : ''}`}>
            <div className="modal-header">
              <h6 className="modal-title" id="addNewGroupLabel">
                Bulk {capitalize(title)}
              </h6>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"></button>
            </div>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                if (!viewPage) {
                  return;
                }
                return submitForm;
              }}
              ref={formBulk}>
              <div className="modal-body">
                <div className="form-group">
                  <div className="">
                    <div className="card">
                      <div className="card-body">
                        <h5 className="card-title">Select your file</h5>
                        <h6 className="card-subtitle mb-2 text-muted">
                          Please add a file xls or xlsx for bulk {title}
                        </h6>
                        <input
                          className="btn-reset"
                          type="reset"
                          ref={resetForm}
                          value="reset"
                        />
                        <input
                          type="file"
                          ref={fileBulk}
                          className="form-control attach-file"
                          name="fileBulk"
                          accept=".xls,.xlsx"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {!viewPage ? (
                  <div className="form-group mg-x-20">
                    {
                      <Select
                        ref={clientsSelected}
                        onChange={handleChange}
                        options={dropdownClients}
                        value={selectedClients}
                        isMulti
                        classNamePrefix="custom"
                      />
                    }
                  </div>
                ) : (
                  []
                )}

                {
                  <div className="content-sn-bulk">
                    {clientSocialNetworks.facebook && (
                      <div className="custom-control custom-checkbox">
                        <input
                          ref={checkFb}
                          type="checkbox"
                          className="custom-control-input"
                          id="bulkCheckFb"
                          defaultChecked
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="bulkCheckFb">
                          Facebook
                        </label>
                      </div>
                    )}

                    {clientSocialNetworks.googleMyBusiness && (
                      <div className="custom-control custom-checkbox">
                        <input
                          ref={checkGmb}
                          type="checkbox"
                          className="custom-control-input"
                          id="bulkCheckGmb"
                          defaultChecked
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="bulkCheckGmb">
                          Google My Business
                        </label>
                      </div>
                    )}

                    {clientSocialNetworks.twitter && (
                      <div className="custom-control custom-checkbox">
                        <input
                          ref={checkTw}
                          type="checkbox"
                          className="custom-control-input"
                          id="bulkCheckTw"
                          defaultChecked
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="bulkCheckTw">
                          Twitter
                        </label>
                      </div>
                    )}
                    {clientSocialNetworks.instagram && (
                      <div className="custom-control custom-checkbox">
                        <input
                          ref={checkIg}
                          type="checkbox"
                          className="custom-control-input"
                          id="bulkCheckIg"
                          defaultChecked
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="bulkCheckIg">
                          Instagram
                        </label>
                      </div>
                    )}
                  </div>
                }
              </div>

              <div className="modal-footer">
                <ProgressBar
                  progress={progress}
                  loaded={loaded}
                  isActive={isBulking}
                />
                <button
                  type="button"
                  className="btn btn-secondary tx-13"
                  data-dismiss="modal"
                  ref={modalDismiss}>
                  Close
                </button>
                <ButtonLoad
                  state={isBulking}
                  text={'Bulk'}
                  icon={'fa-upload'}
                  btn={'btn-primary btn-bulk-group'}
                  type={'submit'}
                  callback={(e) => {
                    submitForm(e);
                  }}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkModal;
